import React, { Component } from "react";
import withAuth from "../auth_components/js/withAuth";
import Navbar from "../Components/Navbar";
import { GetData } from "../api/service";
import { LinearProgress, Typography } from "@material-ui/core";
import FacultyHomePage from "../Components/Faculty/FacultyHomePage";
import FacultyBasic from "../Components/Faculty/FacultyBasic";
import FacultySeminar from "../Components/Faculty/FacultySeminar";
import FacultyResearch from "../Components/Faculty/FacultyResearch";
import FacultyPublications from "../Components/Faculty/FacultyPublications";
import FacultyWorkshop from "../Components/Faculty/FacultyWorkshop";
import FacultyPhd from "../Components/Faculty/FacultyPhd";
import FacultyInvolvement from "../Components/Faculty/FacultyInvolvement";
import FacultyAchievements from "../Components/Faculty/FacultyAchievements";
import FacultyAward from "../Components/Faculty/FacultyAward";
import FacultyOthers from "../Components/Faculty/FacultyOthers";
import FacultyResearchGuideship from "../Components/Faculty/FacultyResearchGuideship";

class FacultyHomeLanding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      employee_id: "",
      active: 0,
      isDeptLoaded: false,
      dept_code: "",
    };
  }



  getDeptCodeFromParams = (props = this.props) => {
    if (!props.match || !props.match.params || !props.match.params.employee_id) {
      return "";
    }

    return String(props.match.params.employee_id).toUpperCase();
  };

  resolveDeptCode = (props = this.props) => {
    return this.getDeptCodeFromParams(props);
  };

   __getDeptData = (employee_id) => {
    GetData(`/admin/${employee_id}/getsingleempolyeedata`).then((resp) => {
      if (resp != false) {
        this.setState({
          data: resp,
          active: 0,
          isDeptLoaded: true,
        });
      } else {
        this.setState({
          data: {},
          active: 0,
          isDeptLoaded: true,
        });
      }
    });
  };

  loadDepartmentData = (props = this.props) => {
    const employee_id = this.resolveDeptCode(props);

    if (employee_id !== "") {
      this.setState({ isDeptLoaded: false, employee_id: employee_id }, () => {
        this.__getDeptData(employee_id);
      });
      return;
    }

    this.setState({
      data: {},
      active: 0,
      isDeptLoaded: true,
      employee_id: "",
    });
  };

  componentDidMount() {
    this.loadDepartmentData();

    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const user = storedUser.user || {};

    this.setState({
      apikey: user.apikey || "",
      username: user.username || "",
    });
  }

  componentDidUpdate(prevProps) {
    const previousDeptCode = this.resolveDeptCode(prevProps);
    const currentDeptCode = this.resolveDeptCode(this.props);

    if (previousDeptCode !== currentDeptCode) {
      this.loadDepartmentData(this.props);
    }
  }

  render() {
    const linkType =
      this.props.match && this.props.match.params
        ? this.props.match.params.link
        : "";

    return (
      <div>
        <Navbar history={this.props.history} />
        <div className="main-body">
          {!this.state.isDeptLoaded ? (
            <LinearProgress color="secondary" />
          ) : null}

          <div
            style={{
              marginBottom: 20,
              backgroundColor: "white",
              padding: 20,
              boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2)",
              borderRadius: 10,
            }}
          >
            <Typography variant="h6">{linkType.toUpperCase()}</Typography>
            <Typography variant="body2">
              Profile: {this.state.data.name || "N/A"}
            </Typography>


           
            
          </div>

           {this.state.isDeptLoaded && linkType === "home" && <div>
              <FacultyHomePage
                {...this.state.data}
                type="liveNow"
                title="Faculty Home Page"
                value={this.state.data.liveNow}
                employee_id={this.state.employee_id}
              />
              </div>}

              {this.state.isDeptLoaded && linkType === "about-me" && <div>
                <FacultyBasic
                {...this.state.data}
                m_type="basic"
                title="Basic Details"
                value={this.state.data.basic}
                employee_id={this.state.employee_id}
              />
              </div>}

              {this.state.isDeptLoaded && linkType === "seminars" && <div>
               <FacultySeminar
                {...this.state.data}
                m_type="seminar"
                title="Seminar Participated"
                value={this.state.data.seminar}
                employee_id={this.state.employee_id}
              />
              </div>}

{this.state.isDeptLoaded && linkType === "research" && <div>
               <FacultyResearch
                {...this.state.data}
                m_type="research"
                title="Research Projects"
                value={this.state.data.research}
                employee_id={this.state.employee_id}
              />
              </div>}

              {this.state.isDeptLoaded && linkType === "publications" && <div>
               <FacultyPublications
                {...this.state.data}
                m_type="publications"
                title="Publications"
                value={this.state.data.publications}
                employee_id={this.state.employee_id}
              />
              </div>}
              {this.state.isDeptLoaded && linkType === "workshops" && <div>
               <FacultyWorkshop
                {...this.state.data}
                m_type="workshop"
                title="Orientation programme/Refresher Course/Short term course"
                value={this.state.data.workshop}
                employee_id={this.state.employee_id}
              />
              </div>}
               {this.state.isDeptLoaded && linkType === "phd" && <div>
               <FacultyPhd
                {...this.state.data}
                m_type="phd"
                title="PhD and M.Phill"
                value={this.state.data.phd}
                employee_id={this.state.employee_id}
              />
              </div>}

               {this.state.isDeptLoaded && linkType === "involvement" && <div>
                <FacultyInvolvement
                {...this.state.data}
                m_type="involvement"
                title="Involvement in College and Outside"
                value={this.state.data.involvement}
                employee_id={this.state.employee_id}
              />
              </div>}

              {this.state.isDeptLoaded && linkType === "achievements" && <div>
                <FacultyAchievements
                {...this.state.data}
                m_type="cocurricular"
                title="Any other Information"
                value={this.state.data.cocurricular}
                employee_id={this.state.employee_id}
              />
              </div>}

              {this.state.isDeptLoaded && linkType === "awards" && <div>
                <FacultyAward
                {...this.state.data}
                m_type="awards"
                title="Awards Received"
                value={this.state.data.awards}
                employee_id={this.state.employee_id}
              />
              </div>}

              {this.state.isDeptLoaded && linkType === "others" && <div>
               <FacultyOthers
                {...this.state.data}
                m_type="others"
                title="Others"
                value={this.state.data.others}
                employee_id={this.state.employee_id}
              />
              </div>}

{this.state.isDeptLoaded && linkType === "guideship" && <div>
               <FacultyResearchGuideship
                {...this.state.data}
                m_type="guideship"
                title="Research Guideship"
                value={this.state.data.guideship}
                employee_id={this.state.employee_id}
              />
              </div>}
               


         
        </div>
      </div>
    );
  }
}

export default withAuth(FacultyHomeLanding);



// WEBPACK FOOTER //
// ./src/Containers/FacultyHomeLanding.js